import React from "react";
import {ColorValue, StyleProp, Text, TextProps, TextStyle} from "react-native";
import {DimensionValue} from "react-native/Libraries/StyleSheet/StyleSheetTypes";

interface Props extends TextProps {
  color?: ColorValue;
  fs?: number;
  fw?: '400' | '500' | '600' | '700' | 400 | 500 | 600 | 700;
  ls?: number;
  lh?: number;
  ta?: 'auto' | 'left' | 'right' | 'center' | 'justify';
  tt?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  ml?: DimensionValue;
  mb?: DimensionValue;
  mt?: DimensionValue;
  flex?: number;
  fShrink?: number;
  maxW?: DimensionValue;
  bw?: number;
  w?: DimensionValue;
  borderColor?: ColorValue;
  px?: DimensionValue;
  my?: DimensionValue;
  mx?: DimensionValue;
  mr?: DimensionValue;
  opacity?: number;
  maxHeight?: DimensionValue;
  borderRadius?: number;
  borderWidth?: number;
  bg?: ColorValue;
  position?: 'absolute' | 'relative';
  textDecorationLine?: 'none' | 'underline' | 'line-through' | 'underline line-through';
  minW?: DimensionValue;
  borderHorizontalWidth?: number;
  fontFamily?: 'Barlow-Regular' | 'Barlow-Medium' | 'Barlow-SemiBold' | 'Barlow-Bold' | 'Alternox-Regular' | 'Alternox-SemiBold' | 'Alternox-Bold' | 'DavisSans-Regular' | 'DavisSans-Medium' | 'POI Aeronaut' | 'POI Orbiter' | 'StratosBoldItalic';
  h?: DimensionValue;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  roundedTop?: number;
  fontStyle?: 'normal' | 'italic';
  fontVariant?: TextStyle['fontVariant'];
}

const P = (props: Props) => {
  const {
    children, style, color, fs, fw, ls, lh, ta, tt, ml, mb, flex, fShrink, maxW, bw, w, borderColor, px, my, mx,
    opacity, mr, maxHeight, borderRadius, borderWidth, bg, position, textDecorationLine, minW, borderHorizontalWidth,
    fontFamily, h, mt, top, right, bottom, left, roundedTop, fontStyle, fontVariant, ...rest
  } = props;
  let Style: StyleProp<TextStyle> = [{color: 'white', fontSize: 16, fontFamily: 'Barlow-Regular'}];

  if (color) Style.push({color});
  if (fs) Style.push({fontSize: fs});

  if (fw === '400' || fw === 400) Style.push({fontFamily: 'Barlow-Regular'});
  if (fw === '500' || fw === 500) Style.push({fontFamily: 'Barlow-Medium'});
  if (fw === '600' || fw === 600) Style.push({fontFamily: 'Barlow-SemiBold'});
  if (fw === '700' || fw === 700) Style.push({fontFamily: 'Barlow-Bold'});

  if (ls) Style.push({letterSpacing: ls});
  if (lh) Style.push({lineHeight: lh});
  if (ta) Style.push({textAlign: ta});
  if (tt) Style.push({textTransform: tt});
  if (ml) Style.push({marginLeft: ml});
  if (mb) Style.push({marginBottom: mb});
  if (flex) Style.push({flex});
  if (fShrink) Style.push({flexShrink: fShrink});
  if (maxW) Style.push({maxWidth: maxW});
  if (bw) Style.push({borderWidth: bw});
  if (borderHorizontalWidth) Style.push({borderLeftWidth: borderHorizontalWidth, borderRightWidth: borderHorizontalWidth});
  if (w) Style.push({width: w});
  if (borderColor) Style.push({borderColor});
  if (px) Style.push({paddingHorizontal: px});
  if (my) Style.push({marginVertical: my});
  if (mx) Style.push({marginHorizontal: mx});
  if (mr) Style.push({marginRight: mr});
  if (maxHeight) Style.push({maxHeight});
  if (opacity) Style.push({opacity});
  if (borderRadius) Style.push({borderRadius});
  if (borderWidth) Style.push({borderWidth});
  if (bg) Style.push({backgroundColor: bg});
  if (position) Style.push({position});
  if (textDecorationLine) Style.push({textDecorationLine});
  if (minW) Style.push({minWidth: minW});
  if (fontFamily) Style.push({fontFamily});
  if (h) Style.push({height: h});
  if (mt) Style.push({marginTop: mt});
  if (top !== undefined) Style.push({top});
  if (right !== undefined) Style.push({right});
  if (bottom !== undefined) Style.push({bottom});
  if (left !== undefined) Style.push({left});
  if (typeof roundedTop === 'number') Style.push({borderTopRightRadius: roundedTop, borderTopLeftRadius: roundedTop});
  if (fontVariant) Style.push({fontVariant});

  if (style && Array.isArray(style)) Style = [...style];
  else if (style) Style.push(style);

  Style.push({fontStyle});

  return <Text style={Style} {...rest}>{children}</Text>
};

export default React.memo(P);
